module.exports = __webpack_public_path__ + "static/logo-research-66210b1ab9ce1f603bea4dbcd9fe44be.svg";